import React from 'react';
import { Icon } from 'semantic-ui-react';

import CustomerMigration from './CustomerMigration';

export default {
  label: 'Customer Migration',
  url: '/t/customer-migration',
  icon: <Icon name="truck" />,
  content: CustomerMigration,
};
